module.exports = __webpack_public_path__ + "static/media/home_1.6a1635c7.jpg";